var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export function registerEmployees(c, payload) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield c.client.fetch(c.baseUrl.joinPath("/v1/manage/organizations", payload.companyId, "/employees"), {
            method: "POST",
            body: JSON.stringify({
                enabled: true,
                shouldNotify: true,
                data: payload.employees.map((e) => {
                    var _a;
                    return ({
                        id: e.id,
                        userId: e.userId,
                        netSalary: e.netSalary,
                        withdrawPercentage: (_a = e.withdrawPercentage) !== null && _a !== void 0 ? _a : 80,
                        withdrawBehaviour: "early",
                    });
                }),
            }),
            headers: {
                "Idempotent-Key": payload.idempotentKey,
                "Content-Type": "application/json",
            },
        });
        return yield res.json();
    });
}
